import { Injectable } from '@angular/core'
import { FileType, IFile } from '@adex/shared/models/file'
import * as download from 'downloadjs'


@Injectable({
  providedIn: 'root'
})
export class FileSavingService {

  constructor() {
  }

  public save(fileObj: IFile): void {
    const { file, fileName, fileType } = fileObj
    const mineType = FileSavingService.getType(fileType)
    try {
      download(`data:${ mineType };base64,${ file }`, fileName, mineType)
    } catch (err) {
      console.error(err)
    }
  }

  private static getType(fileType: FileType): string {
    if (fileType === FileType.PDF) return 'application/pdf'
    if (fileType === FileType.CSV) return 'text/csv'
    return ''
  }
}
